module.exports = __webpack_public_path__ + "static/media/NadirDurrani_square.4602d68f.JPG";